/**
 * This is a wrapper module around the `page-modules` js loader
 * 
 * It is designed to return a promise when all of the `init()` methods have been ran for the current page
 * @module load-page-modules
 */
import {awaitLoad} from '../page-modules/page-modules';

/**
 * This helper method runs all the `init()` methods for the given page. 
 * This works by looping through all of the classes on the main `<body>` element
 * 
 * @name load-page-modules
 * @function
 * @returns {Promise} Resovles the promise when all methods have been ran
 * 
 * @example
 * // Init Page Modules
 * loadPageModules()
 *     .then(() => console.log("Page modules loaded"));
 */
export default () => {
    return new Promise((resolve, reject) => {
        // Run page specific code when it loads up
        document.body.className.split(/\s+/).forEach(function (value) {
            awaitLoad(value,null).then(function (result) {
                window[value].init.bind(window)();
                resolve(result);
            }, function (err) {
                // Fail silently
                console.log("PageModule:", err);
                document.querySelector('.body-content')?.classList.add('loaded');
                //reject(err);
            });

        });
    });
};